(function() {
  'use strict';

  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    // Mark JS as ready (CSS hides reveal targets only when this class is present)
    document.documentElement.classList.add('rkx-anim-ready');

    if (prefersReduced) {
      document.querySelectorAll('.rkx-anim-ready *').forEach(el => el.classList.add('is-revealed'));
      return;
    }

    // Apply stagger via transition-delay for siblings
    const STAGGER_PARENTS = [
      '.rkx-pricing', '.rkx-stats',
      '.rkx-svc-grid', '.rkx-channels__grid',
      '.rkx-svc-includes__grid', '.rkx-blog-grid',
      '.rkx-collection__grid', '.rkx-media',
      '.rkx-process__steps', '.rkx-compare__grid',
      '.rkx-about__values-grid', '.rkx-about__team-grid',
      '.rkx-about__timeline-list', '.rkx-about__stats-strip',
      '.rkx-spage-hero__stats', '.rkx-svc-hero__stats',
      '.rkx-faq__list'
    ];
    STAGGER_PARENTS.forEach(sel => {
      document.querySelectorAll(sel).forEach(parent => {
        Array.from(parent.children).forEach((child, idx) => {
          if (idx > 0 && idx < 10) {
            child.style.transitionDelay = (idx * 75) + 'ms';
          }
        });
      });
    });

    // Above-fold elements reveal immediately
    const viewportH = window.innerHeight;
    const REVEAL_SEL = '.rkx-plan, .rkx-svc-card, .rkx-channel-card, .rkx-svc-includes__card, ' +
                       '.rkx-blog-card, .rkx-blog-featured, .rkx-collection__card, .rkx-media-card, ' +
                       '.rkx-process__step, .rkx-compare__col, .rkx-services__row, ' +
                       '.rkx-stats > div, .rkx-spage-hero__stats > div, ' +
                       '.rkx-svc-hero__stats > div, .rkx-about__stats-strip > div, ' +
                       '.rkx-about__value-card, .rkx-about__team-member, .rkx-about__milestone, ' +
                       '.rkx-process-detail__phase, .rkx-faq__item, ' +
                       '.rkx-h2, .rkx-label';

    document.querySelectorAll(REVEAL_SEL).forEach(el => {
      if (el.closest('.rkx-hero')) return;
      const rect = el.getBoundingClientRect();
      if (rect.top < viewportH * 0.92) {
        requestAnimationFrame(() => requestAnimationFrame(() => {
          el.classList.add('is-revealed');
        }));
      }
    });

    // Below-fold: IntersectionObserver
    if ('IntersectionObserver' in window) {
      const obs = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            if (entry.target.classList.contains('rkx-stat__num') ||
                entry.target.matches('.rkx-stats > div, .rkx-spage-hero__stats > div, .rkx-svc-hero__stats > div, .rkx-about__stats-strip > div')) {
              const num = entry.target.querySelector('.rkx-stat__num, .rkx-spage-hero__stat-num, .rkx-svc-hero__stat-num, .rkx-about__stat-num');
              if (num) animateCount(num);
            }
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });

      document.querySelectorAll(REVEAL_SEL).forEach(el => {
        if (!el.classList.contains('is-revealed')) obs.observe(el);
      });
    } else {
      document.querySelectorAll(REVEAL_SEL).forEach(el => el.classList.add('is-revealed'));
    }

    // Count-up animation
    function animateCount(el) {
      if (el.dataset.rkxCounted) return;
      el.dataset.rkxCounted = '1';

      const suffixEl = el.querySelector('span');
      const suffixHTML = suffixEl ? suffixEl.outerHTML : '';
      const clone = el.cloneNode(true);
      const cloneSpan = clone.querySelector('span');
      if (cloneSpan) cloneSpan.remove();
      const numText = clone.textContent.trim();

      let multiplier = 1;
      let formatSuffix = '';
      let text = numText;
      const kMatch = text.match(/^([\d,\.]+)\s*[kK]$/);
      const mMatch = text.match(/^([\d,\.]+)\s*[mM]$/);
      if (kMatch) { multiplier = 1000; formatSuffix = 'K'; text = kMatch[1]; }
      else if (mMatch) { multiplier = 1000000; formatSuffix = 'M'; text = mMatch[1]; }
      const target = parseFloat(text.replace(/,/g, ''));
      if (isNaN(target)) return;
      const finalValue = target * multiplier;
      const duration = 1500;
      const startTime = performance.now();

      function format(val) {
        if (formatSuffix === 'K') return Math.round(val / 1000) + 'K';
        if (formatSuffix === 'M') return (Math.round(val / 100000) / 10).toFixed(1) + 'M';
        if (target < 100 && numText.indexOf('.') === -1) return Math.round(val).toString();
        return Math.round(val).toLocaleString();
      }
      function tick(now) {
        const elapsed = now - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        const current = finalValue * eased;
        el.innerHTML = format(current) + suffixHTML;
        if (progress < 1) requestAnimationFrame(tick);
        else el.innerHTML = numText + suffixHTML;
      }
      el.innerHTML = format(0) + suffixHTML;
      requestAnimationFrame(tick);
    }

    // Header scroll state
    const header = document.querySelector('.rkx-header');
    if (header) {
      let ticking = false;
      function updateHeader() {
        if (window.scrollY > 32) header.classList.add('is-scrolled');
        else header.classList.remove('is-scrolled');
        ticking = false;
      }
      window.addEventListener('scroll', () => {
        if (!ticking) { requestAnimationFrame(updateHeader); ticking = true; }
      }, { passive: true });
      updateHeader();
    }

    // Smooth scroll for in-page anchors
    document.addEventListener('click', e => {
      const link = e.target.closest('a[href^="#"]');
      if (!link) return;
      const href = link.getAttribute('href');
      if (href === '#' || href.length < 2) return;
      const target = document.getElementById(href.slice(1));
      if (!target) return;
      e.preventDefault();
      const top = target.getBoundingClientRect().top + window.scrollY - 100;
      window.scrollTo({ top, behavior: 'smooth' });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
